import React from "react";
import FilterSelectInputSearch from "./FilterSelectInputSearch";
import { loadingTpl } from "../FilterSelect/FilterSelect";
/**
 * Renders the checkbox list for the logical operator combination Equals/String
 */
const LogicalOperatorEqualsListView = (props) => {
  return (
    <>
      <div className="p-2">
        <FilterSelectInputSearch {...props} />
      </div>
      {props.loadingStatus === "loading" ? (
        <div>{loadingTpl}</div>
      ) : props.loadingStatus === "loaded" && !props.data.length ? (
        <div>
          <div className="mt-3 mr-3 ml-3 text-center filter-no-items-found">
            <span>Item not found.</span>
          </div>
        </div>
      ) : (
        props.checkboxList.map((el, ind) => {
          if (
            !props.valueInputSearch ||
            el.friendlyName
              .toLowerCase()
              .indexOf(props.valueInputSearch.toLowerCase()) !== -1 ||
            // if, at least, the current code is part of the search input
            props.valueInputSearch.includes(el.friendlyName)
          )
            return (
              <li key={ind} className="filter-menu-opt-item">
                <input
                  name={"checkbox_" + el.friendlyName}
                  id={"checkbox_" + el.friendlyName}
                  type="checkbox"
                  className="filter-menu-item-checbox"
                  checked={el.checked || false}
                  onChange={() => props.handleInputChange(ind)}
                />
                <label htmlFor={"checkbox_" + el.friendlyName}>
                  {el.friendlyName}
                </label>
              </li>
            );
          return null;
        })
      )}{" "}
    </>
  );
};

export default LogicalOperatorEqualsListView;
